import { DNComment, Content } from './content.model';
import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';
import { ErrorMessage } from '../error/error-message.model';

// Search

export interface ContentListSearchState extends EntityState<Content> {
	error: ErrorMessage;
}

export const contentListSearchAdapter: EntityAdapter<Content> = createEntityAdapter<Content>({
	selectId: (contentsSearchList) => contentsSearchList.idContenuto
});

export const contentListSearchInitialState: ContentListState = contentListSearchAdapter.getInitialState(
	{
		error: undefined
	}
);

export const contentListSearchSelectors = contentListSearchAdapter.getSelectors();

// List

export interface ContentListState extends EntityState<Content> {
	error: ErrorMessage;
}

export const contentListAdapter: EntityAdapter<Content> = createEntityAdapter<Content>({
	selectId: (contentList) => contentList.idContenuto
});

export const contentListInitialState: ContentListState = contentListAdapter.getInitialState({
	error: undefined
});

export const contentListSelectors = contentListAdapter.getSelectors();

// Current

export interface CurrentContentState extends EntityState<Content> {
	comments: DNComment[];
	temporaryMediaName: string;
	error: ErrorMessage;
}

export const contentAdapter: EntityAdapter<Content> = createEntityAdapter<Content>({
	selectId: (content) => content.idContenuto
});

export const contentInitialState: CurrentContentState = contentAdapter.getInitialState({
	comments: [],
	temporaryMediaName: '',
	error: <ErrorMessage>{}
});

export const contentSelectors = contentAdapter.getSelectors();
